import React, { Component } from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { withRouter } from 'react-router-dom';
import { message, BackTop, Modal } from 'antd';
import store from 'store';
import qs from 'qs';

// components
import IndexHead from '@/components/IndexHeader/IndexHead';
import IndexNavigation from '@/components/IndexNavigation/IndexNavigation';
import IndexContent from '@/components/IndexContent/IndexContent';
import Copyright from '@/components/Copyright/Copyright';
import ModifyEmail from '@/components/ModifyEmail/ModifyEmail';
import IndexTabsNavigation from '@/components/IndexTabsNavigation/IndexTabsNavigation';
import IndexIframe from '@/components/IndexIframe/IndexIframe';


// utils
import {
  getArray,
  qtPagePvFun,
  hrefHomeByToken,
  checkPasswordExpiration,
  hrefUserHomeInfo,
  checkIsLaunchpad,
  handleZentaoRedirect
} from '@/utils/util';
import iconList from '@/utils/iconList';

// api
import { menu, userRoleGet } from '@/api/index';
import { isNeedModifyEmail, isNeedModifyPass, checkToken } from '@/api/login';
import { userTenantLogin, checkIntranet } from '@/api/tenant';

import Logo from '@/assets/images/logo.png';

// stylus
import './index.styl';
import { getParam, removeParam } from 'ruigu-utils';

let menuBack = [];
class Index extends Component {
  state = {
    menu: [],
    systemList: [],
    allModule: [],
    openModule: [],
    openModuleId: -1,
    removeModuleId: -1,
    headerMenu: [],
    visibleBindMailbox: false,
    opera: '',
    isReturnURL: false,
  };

  componentDidMount() {
    const isReturnURL =
      getParam('returnURL') || window.sessionStorage.getItem('returnURL');
    this.setState({
      isReturnURL,
    });

    // 登录检测
    if (window.location.href.split('?')[1] !== undefined && getParam('code')) {
      this.handleComfirmSweepCode();
      if (isReturnURL) return;
    } else {
      this.init();
    }
  }

  async init() {
    try {
      const token = store.get('token');
      if (typeof token === 'undefined' || token === '') {
        this.props.history.push('/login');
        return;
      }

      // 校正首页-防止用户私自切换首页路由
      const userInfo = store.get('userInfo') || (await checkToken(token)) || {};
      if (!userInfo.bizOrgType) {
        store.remove('token');
        localStorage.clear();
        this.props.history.push('/login');
        return;
      } else if (![1].includes(userInfo.bizOrgType) || !checkIsLaunchpad()) {
        this.props.history.push('/home');
        return;
      } else {
        const isInternet = await checkIntranet();
        if (!isInternet) {
          message.warning('请使用锐锢内网或锐锢VPN访问');
          setTimeout(() => {
            store.remove('token');
            localStorage.clear();
            this.props.history.push('/login');
          }, 2000);
          return;
        }
      }

      if (!getParam('backFlag')) {
        const roleList = (await userRoleGet({
          userIdList: [userInfo.id],
          ruleCodeList: ['采购工作台-自动进入']
        })) || [];
        if (roleList.length > 0) {
          this.props.history.push('/home?board_group=2');
          return;
        }
      }

      // 缓存userInfo
      store.set('userInfo', userInfo);

      // 获取全部菜单
      this.getMenu();

      // 检测邮箱是否需要修改
      // this.handleCheckEmail();

      // 检测密码是否需要修改
      // this.handleCheckPassword()

      // 监听postMessage
      this.eventListener();

      // 读取缓存
      this.readCacheOpenModule();

      // 首页查询密码有效期进行提醒
      const loginType = JSON.parse(window.localStorage.getItem('loginType') || '{}');
      if (loginType && loginType.type === 'password' && !loginType.isAlert) {
        checkPasswordExpiration()
          .then(() => {
            this.onClickModule(hrefUserHomeInfo('4'));
          })
          .catch(() => { });
      }
    } catch (err) {
      message.warning(err.message);
    }
  }

  /**
   * 监听postMessage
   */
  eventListener() {
    window.addEventListener('message', ({ data }) => {
      // 获取postMessage数据
      const {
        url,
        params = {},
        isOpenNewTab = false,
        title = '',
        systemId = '',
        id,
        menuUrl,
        children,
        type,
      } = data;
      if (url === undefined) return;

      // 检测要打开的url是否存在
      let urlObj = this.state.allModule.find((item) => item.path.includes(url));
      if (urlObj === undefined && !isOpenNewTab) return;

      // 其他需要打开新标签的系统逻辑
      if (isOpenNewTab) {
        urlObj = {
          id: id || title,
          title,
          path: url,
          backPath: url,
          isOpenNewTab,
          systemId,
          menuUrl,
          children,
          type,
        };
      }

      // 获取url参数
      const paramsList = [];
      for (let item in params) {
        paramsList.push(`${item}=${params[item]}`);
      }
      const paramsString = paramsList.join('&');

      // 设置请求参数
      urlObj.path = urlObj.backPath.includes('?')
        ? `${urlObj.backPath}&${paramsString}`
        : `${urlObj.backPath}?${paramsString}`;

      // 打开页面
      this.onClickModule(urlObj, true);
    });
  }

  /**
   * 检查是否需要修改邮箱
   */
  handleCheckEmail() {
    isNeedModifyEmail()
      .then((res) => {
        if (res === true) {
          this.setState({ visibleBindMailbox: true });
        }
      })
      .catch((err) => {
        message.warning(err.message);
      });
  }

  /**
   * 检查是否需要修改密码
   */
  handleCheckPassword() {
    isNeedModifyPass()
      .then((res) => {
        const { message = '', result = false } = res;
        if (result === true) {
          // 需要修改密码
          Modal.confirm({
            title: message,
            icon: <ExclamationCircleOutlined />,
            // content: '是否前往修改密码?',
            okText: '立即修改',
            cancelButtonProps: {
              style: {
                display: 'none',
              },
            },
            onOk: () => {
              console.log('OK');
              const updateUrl = {
                path: `${process.env.REACT_APP_API}/passport/profile/resetPwd`,
                id: 'updatePassWord',
                title: '修改密码',
                permCode: '修改密码',
                backPath: '',
              };
              this.onClickModule(updateUrl);
            },
            onCancel() {
              console.log('Cancel');
            },
          });
        }
      })
      .catch((err) => {
        message.warning(err.message);
      });
  }

  /**
   * 关闭弹框
   * @param visible 开关标记
   */
  handleCloseModal(visible) {
    this.setState({ visibleBindMailbox: visible });
  }

  /**
   * 确认扫码登录
   */
  async handleComfirmSweepCode() {
    try {
      const queryString = window.location.href.split('?')[1];
      const queryObj = qs.parse(queryString);
      const params = {
        grantType: 'scan',
        code: queryObj.code,
        agentId: queryObj.state,
        clientId: process.env.REACT_APP_CLIENT_ID,
      };
      removeParam('code');
      removeParam('state');
      const { token, bizOrgList, userIdentity } = await userTenantLogin(params);
      if (token && token.access_token) {
        this.token = token.access_token;
        store.set('isSweepCodeLogin', true);
        hrefHomeByToken(
          token.access_token,
          bizOrgList,
          userIdentity,
          this.props.history,
          () => {
            this.init();
          },
        );
      }
    } catch (err) {
      message.warning(err.message);
    }
  }

  /**
   * 获取菜单
   * @returns {Promise<void>}
   */
  async getMenu() {
    try {
      const menuList = getArray(await menu()).filter(
        (item) => getArray(item.children).length > 0,
      ); // 获取系统数组、过滤没有模块的系统

      const systemList = this.setSystemList(menuList);
      const formatMenu = this.setModulePower(this.setMenuList(menuList));
      const allModule = this.setAllModule(formatMenu);
      menuBack = [...formatMenu];

      this.setState({
        menu: formatMenu,
        headerMenu: formatMenu,
        systemList,
        allModule,
      });
    } catch (e) {
      message.warning(e.message || '获取菜单失败');
    }
  }

  /**
   * 设置菜单
   * @param menu
   * @returns {[]}
   */
  setMenuList(menu) {
    const menuList = [];

    for (let {
      id,
      title,
      children,
      path = '',
      menuDescription = '',
      icon = '',
      type,
      permCode,
    } of menu) {
      const otherModule = []; // 系统模块

      const obj = {
        id,
        title,
        path,
        backPath: path,
        menuDescription,
        icon,
        type,
        permCode,
        children: getArray(children).map((item) => {
          this.setMenuList(item.children).map((childItem) => {
            return item.type !== 1 ? otherModule.push(childItem) : '';
          });
          return {
            id: item.id,
            title: item.title,
            path: item.path || '',
            backPath: item.path || '',
            icon: item.icon,
            menuDescription: item.menuDescription,
            type: item.type,
            children: item.type !== 1 ? [] : item.children,
            permCode: item.permCode,
          };
        }),
      };

      obj.children =
        otherModule.length !== 0
          ? [...obj.children, ...otherModule]
          : obj.children;

      menuList.push(obj);
    }

    return menuList;
  }

  /**
   * 设置系统模块权限
   * @param menu
   * @returns {*}
   */
  setModulePower(menu) {
    for (let item of menu) {
      if (
        item.children.length > 0 &&
        this.checkNeedPowerPath(item.children[0].path)
      ) {
        const powerModuleList = item.children.map((item) => {
          const keyword = item.path.match(/#\/([a-zA-Z0-9-]{1,})/gi);

          if (!Array.isArray(keyword)) return '';

          const keywordArr = keyword.join().split('#/');
          if (keywordArr.length === 2) {
            return keywordArr[1];
          } else {
            return '';
          }
        });

        const powerModuleString = `menuList=${encodeURIComponent(
          powerModuleList.join('|'),
        )}`;
        for (let childItem of item.children) {
          childItem.path = childItem.path.includes('?')
            ? `${childItem.path}&${powerModuleString}`
            : `${childItem.path}?${powerModuleString}`;
          childItem.backPath = childItem.backPath.includes('?')
            ? `${childItem.backPath}&${powerModuleString}`
            : `${childItem.backPath}?${powerModuleString}`;
        }
      }
    }

    return menu;
  }

  /**
   * 获取所有系统、模块的名称、id
   * @param menu
   * @returns {*}
   */
  setSystemList(menu) {
    const systemList = menu.map(({ id, title }) => {
      return {
        title,
        id,
        active: false, // 是否被选择
        iconClassName:
          (
            iconList.find(({ keyword }) => {
              return keyword.find((item) => title.includes(item));
            }) || {}
          ).iconClassName || '', // icon
      };
    });

    systemList.unshift({
      title: '全部',
      id: '',
      active: true, // 是否被选择
      iconClassName: 'icon-quanbu-33x', // icon
    });

    return systemList;
  }

  /**
   * 获取所有模块
   * @param systemList
   * @returns {*}
   */
  setAllModule(systemList) {
    return this.flatten(systemList.map(({ children }) => children));
  }

  flatten(input) {
    const stack = [...input];
    const res = [];
    while (stack.length) {
      // pop value from stack
      const next = stack.pop();
      if (Array.isArray(next)) {
        // push back array items, won't modify the original input
        stack.push(...next);
      } else {
        res.push(next);
      }
    }
    //reverse to restore input order
    return res.reverse();
  }

  /**
   * 点击导航条
   * @param index 导航索引
   */
  onClickNavigation(index) {
    this.setState({
      systemList: this.state.systemList.map((item, listIndex) => {
        item.active = index === listIndex;

        if (index === listIndex) {
          this.setClickMenu(item.id);
          item.active = true;
        } else {
          item.active = false;
        }
        return item;
      }),
    });
  }

  /**
   * 设置点击的系统
   * @param id
   */
  setClickMenu(id) {
    this.setState({
      menu: id === '' ? menuBack : [menuBack.find((item) => item.id === id)],
    });
  }

  /**
   * 检测需要配置菜单权限的系统
   * @param path
   * @returns {boolean}
   */
  checkNeedPowerPath(path) {
    const needMenuListUrl = ['goods-sys.ruigushop'];
    return needMenuListUrl.some((item) => path.includes(item));
  }

  /**
   * 模块点击
   * @param id 模块id
   * @param path 模块路径
   * @param title 模块名称
   * @param backPath 路径备份
   * @param 是否系统内部打开页面 路径备份
   * @param systemId 模块id
   */
  onClickModule(options, isNotPv) {
    console.log('onClickModule-----', options);
    let {
      id,
      path,
      icon,
      title,
      backPath,
      isOpenNewTab,
      systemId = '',
      type,
      children = [],
      menuUrl,
      permCode,
    } = options;
    if (path === undefined || path === null) return;
    // 禅道免登录跳转拦截
    if (handleZentaoRedirect(options)) return;
    // 采购工作台
    if (permCode === 'task-data-launchpad') {
      store.set('openModule', null);
      store.set('openModuleOpenInfo', null);
      return this.props.history.push('/home?board_group=2');
    }

    // 页面曝光
    if (!isNotPv && path !== `${window.location.origin}/menuLayout`) {
      qtPagePvFun(path);
    }

    // 外部打开（新窗口不是 iframe，收不到 postMessage 回投，token 需由 URL 携带）
    if ((permCode || '').startsWith('windowOpen-')) {
      const addString = `access_token=${store.get('token') || ''}&id=${isOpenNewTab ? systemId : id}`;
      const openPath = path.includes('?') ? `${path}&${addString}` : `${path}?${addString}`;
      return window.open(openPath);
    }

    // iframe 内嵌打开不拼 token，子应用经 postMessage 回投获取
    const addString = `id=${isOpenNewTab ? systemId : id}`;
    path = path.includes('?') ? `${path}&${addString}` : `${path}?${addString}`;

    // 回溯寻找顶部和左侧菜单
    if (!title && menuUrl) {
      const stateInfo = this.state.allModule.find((item) => {
        const newUrl = menuUrl
          .replace(/http:\/\/|https:\/\/|\/\//, '')
          .replace(/test.|dev.|uat./, '')
          .split('?')[0];
        if (item.path.includes(newUrl)) {
          return true;
        } else {
          return false;
        }
      });
      title = stateInfo.title || '';
    }

    // 页面没有被打开，模块信息存储至state
    if (!this.state.openModule.some((item) => String(item.id) === String(id))) {
      // 聚合菜单记录children信息
      const isMenuLayout = type === 1 ? { type, children } : {};
      const openModule = [
        ...this.state.openModule,
        {
          id: String(id),
          path,
          icon,
          title,
          backPath,
          systemId,
          ...isMenuLayout,
        },
      ];

      this.setState({
        openModule,
        openModuleId: String(id),
        opera: 'open',
      });

      this.cacheOpenModule(openModule);
    }
    const currentMenu = this.state.openModule.filter(
      (item) => String(item.id) === String(id),
    );
    if (isOpenNewTab || currentMenu?.length > 0) {
      this.setState({ openModuleId: String(id) });
    }
  }

  /**
   * 关闭模块
   * @param removeModuleId 模块id
   * @param index 已打开模块索引
   */
  removeModule(removeModuleId, index) {
    const openModule = [...this.state.openModule]; // 已打开模块
    let openModuleId = -1;
    openModule.splice(index, 1); // 删除被关闭的模块

    // 设置模块ID
    if (openModule.length !== 0) {
      openModuleId = openModule[openModule.length - 1].id;
    }

    this.setState({
      openModule,
      openModuleId,
      removeModuleId,
      opera: 'remove',
    });

    this.cacheOpenModule(openModule);
  }

  /**
   * 更新导航高亮模块
   */
  updateOpenModuleId(openModuleId) {
    this.setState({
      openModuleId,
      opera: 'change',
    });
  }

  /**
   * 重置导航高亮模块
   */
  resetRemoveModuleId() {
    this.setState({
      removeModuleId: -1,
      opera: 'remove',
    });
  }

  /**
   * 本地存储打开的url
   * @param openModule 已经打开的模块
   */
  cacheOpenModule(openModule) {
    store.set('openModule', openModule);
  }

  /**
   * 读取本地存储的url
   */
  readCacheOpenModule() {
    const openModule = store.get('openModule') || [];

    if (Array.isArray(openModule) && openModule.length === 0) return;

    // 过滤采购工作台
    const isTaskDataLaunchpad = openModule.find(
      (item) => item.title === '采购工作台',
    );
    if (isTaskDataLaunchpad) {
      store.set('openModule', null);
      store.set('openModuleOpenInfo', null);
      removeParam('board_group');
      removeParam('navIndex');
      return;
    }

    this.setState({
      openModule: openModule.map((item) => {
        const addString = `id=${item.systemId || item.id}`;
        const path = item.backPath
          ? item.backPath.includes('?')
            ? `${item.backPath}&${addString}`
            : `${item.backPath}?${addString}`
          : item.path;
        return {
          ...item,
          path,
        };
      }),
      openModuleId: (openModule[0] || {}).id || -1,
    });
  }

  render() {
    return this.state.isReturnURL ? (
      ''
    ) : (
      <div className="index">
        {/*header*/}
        {this.state.headerMenu && this.state.headerMenu.length > 0 ? (
          <IndexHead
            headerMenu={this.state.headerMenu}
            allModule={this.state.allModule}
            menu={this.state.menu}
            companyLogo={Logo}
            companyName="锐锢中台"
            onClickModule={(e) => this.onClickModule(e)}
          />
        ) : (
          ''
        )}
        <div className="index-header-placeholder" />

        <IndexNavigation
          systemList={this.state.systemList}
          onClickNavigation={this.onClickNavigation.bind(this)}
        />

        {/*system content*/}
        <IndexContent
          menu={this.state.menu}
          history={this.props.history}
          onClickModule={(e) => this.onClickModule(e)}
        />

        {/*Copyright*/}
        {this.state.openModule.length === 0 ? <Copyright /> : ''}

        {/*to top*/}
        {this.state.openModule.length === 0 ? (
          <BackTop className="to-top-icon" />
        ) : (
          ''
        )}

        {/*show*/}
        {this.state.openModule.length > 0 ? (
          <IndexTabsNavigation
            openModule={this.state.openModule}
            openModuleId={this.state.openModuleId}
            updateOpenModuleId={this.updateOpenModuleId.bind(this)}
            removeModule={this.removeModule.bind(this)}
          />
        ) : (
          ''
        )}
        {this.state.openModule.length > 0 ? (
          <IndexIframe
            openModule={this.state.openModule}
            openModuleId={this.state.openModuleId}
            opera={this.state.opera}
            removeModuleId={this.state.removeModuleId}
            resetRemoveModuleId={this.resetRemoveModuleId.bind(this)}
          />
        ) : (
          ''
        )}

        {/* 绑定企业邮箱modal */}
        <ModifyEmail
          visible={this.state.visibleBindMailbox}
          handleCloseModal={(visible) => this.handleCloseModal(visible)}
        />
      </div>
    );
  }
}

export default withRouter(Index);
